import React, { useState, useCallback, useEffect, useRef } from "react";
import { useDropzone } from "react-dropzone";
import { Button } from "reactstrap";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import {
  deleteProjectCheckListImage,
  getProjectCheckListImages,
  saveProjectCheckListImage,
  updateProjectCheckListImage,
  uploadProjectCheckListImage,
} from "../../API";
import { convertToISOString } from "../../utils/utils";
import heic2any from "heic2any";

const AddpicsUnitJobModal = (props) => {
  const { projectCheckListId, isDisabled } = props;
  const [uploadedPics, setUploadedPics] = useState([]);
  const [uploadedMapPics, setUploadedMapPics] = useState([]);
  const [uploadedPicsOrignal, setUploadedPicsOrignal] = useState([]);
  const [isDeleteEnabled, setIsDeleteEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isMapPicUploaded, setIsMapPicUploaded] = useState(false);

  // Sample
  //   {
  //     "id": 2,
  //     "project_check_list_id": 1,
  //     "image_url": "https://webtimefedev.blob.core.windows.net/checklistimage/itachi_sample.jpeg?sv=2024-08-04&st=2025-06-16T05%3A47%3A15Z&se=2026-06-16T05%3A47%3A15Z&sr=b&sp=r&sig=6iCXZAdJsh72M2Lj%2F87PBKR55G7R5f7kVMN6SYSRNVI%3D",
  //     "taken_on": "2025-06-16T00:00:00.000Z",
  //     "type": "after",
  //     "comment": "this iamge is taken before work started",
  //     "created_at": "2025-06-16T05:47:57.162Z",
  //     "updated_at": "2025-06-16T05:47:57.162Z",
  //     "deleted_at": null
  // },

  const fetchUploadedImages = async () => {
    try {
      setIsLoading(true);
      const query = `project_check_list_id=${projectCheckListId}`;
      const imagesData = await getProjectCheckListImages(query);
      if (imagesData?.data && imagesData?.status === 200) {
        setUploadedPicsOrignal(imagesData?.data || []);
        const updatedImages = imagesData.data.map((img, index) => {
          return {
            ...img,
            isEditable: false,
          };
        });
        setUploadedMapPics(updatedImages.filter((img) => img.type === "map"));
        setUploadedPics(updatedImages.filter((img) => img.type !== "map"));
      }

    } catch (error) {
      console.error("Error fetching uploaded images:", error);
      toast.error("Failed to fetch uploaded images");
    } finally {
      setIsLoading(false);
      // setIsDeleteEnabled(false);
    }
  };

  useEffect(() => {
    fetchUploadedImages();
  }, [projectCheckListId]);

  const handleDateChange = (e, id) => {
    const date = convertToISOString(e);
    setUploadedPics((prev) =>
      prev.map((p) => (p.id === id ? { ...p, taken_on: date } : p))
    );
  };

  const handleDateChangeForMap = (e, id) => {
    const date = convertToISOString(e);
    setUploadedMapPics((prev) =>
      prev.map((p) => (p.id === id ? { ...p, taken_on: date } : p))
    );
  };

  const handleTypeChange = (id, newType) => {
    setUploadedPics((prev) =>
      prev.map((p) => (p.id === id ? { ...p, type: newType } : p))
    );
  };
  const handleEditImageCard = (pic) => {

    setUploadedPics((prev) =>
      prev.map((p) =>
        p.id === pic.id ? { ...p, isEditable: !p.isEditable } : p
      )
    );
  };

  const handleEditMapImageCard = (pic) => {

    setUploadedMapPics((prev) =>
      prev.map((p) =>
        p.id === pic.id ? { ...p, isEditable: !p.isEditable } : p
      )
    );
  };


  const handleCancelImageCard = (pic) => {
    const findOrignalPic = uploadedPicsOrignal.find(
      (item) => item.id === pic.id
    );
    setUploadedPics((prev) =>
      prev.map((p) =>
        p.id === pic.id ? { ...findOrignalPic, isEditable: false } : p
      )
    );
  };

  const handleCancelMapImageCard = (pic) => {
    const findOrignalPic = uploadedPicsOrignal.find(
      (item) => item.id === pic.id
    );
    setUploadedMapPics((prev) =>
      prev.map((p) =>
        p.id === pic.id ? { ...findOrignalPic, isEditable: false } : p
      )
    );
  };

  const handleDeleteImageCard = async (pic) => {
    try {
      setIsLoading(true);
      const deleteRes = await deleteProjectCheckListImage(pic.id);
      if (deleteRes?.status === 204) {
        toast.success("Image deleted successfully");
        fetchUploadedImages();
      }
    } catch (error) {
      console.error("Error deleting image:", error);
      toast.error("Failed to delete image");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSaveImageCard = async (pic) => {
    setIsLoading(true);
    setIsDeleteEnabled(false);
    const findOrignalPic = uploadedPicsOrignal.find(
      (item) => item.id === pic.id
    );

    if (
      pic.image_url === findOrignalPic.image_url &&
      pic.comment === findOrignalPic.comment &&
      pic.type === findOrignalPic.type &&
      pic.taken_on === findOrignalPic.taken_on
    ) {
      setUploadedPics((prev) =>
        prev.map((p) => (p.id === pic.id ? { ...p, isEditable: false } : p))
      );
      setIsLoading(false);
      toast.warn("No changes made to save");
      return;
    }
    const id = pic.id;
    const updateImagePayload = {
      image_url: pic.image_url,
      project_check_list_id: pic.project_check_list_id,
      type: pic.type,
      comment: pic.comment,
      taken_on: pic.taken_on,
    };
    try {
      const updatedImageRes = await updateProjectCheckListImage(
        id,
        updateImagePayload
      );
      if (updatedImageRes?.status === 200) {
        setUploadedPics((prev) =>
          prev.map((p) => (p.id === pic.id ? { ...p, isEditable: false } : p))
        );
        fetchUploadedImages();
        toast.success("Image data updated successfully");
      }
    } catch (error) {
      toast.error("Failed to update image data");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSaveMapImageCard = async (pic) => {
    setIsLoading(true);
    setIsDeleteEnabled(false);
    const findOrignalPic = uploadedPicsOrignal.find(
      (item) => item.id === pic.id
    );

    if (
      pic.image_url === findOrignalPic.image_url &&
      pic.comment === findOrignalPic.comment &&
      pic.type === findOrignalPic.type &&
      pic.taken_on === findOrignalPic.taken_on
    ) {
      setUploadedMapPics((prev) =>
        prev.map((p) => (p.id === pic.id ? { ...p, isEditable: false } : p))
      );
      setIsLoading(false);
      toast.warn("No changes made to save");
      return;
    }
    const id = pic.id;
    const updateImagePayload = {
      image_url: pic.image_url,
      project_check_list_id: pic.project_check_list_id,
      type: pic.type,
      comment: pic.comment,
      taken_on: pic.taken_on,
    };
    try {
      const updatedImageRes = await updateProjectCheckListImage(
        id,
        updateImagePayload
      );
      if (updatedImageRes?.status === 200) {
        setUploadedMapPics((prev) =>
          prev.map((p) => (p.id === pic.id ? { ...p, isEditable: false } : p))
        );
        fetchUploadedImages();
        toast.success("Image data updated successfully");
      }
    } catch (error) {
      toast.error("Failed to update image data");
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeComment = (id, comment) => {
    setUploadedPics((prev) =>
      prev.map((p) => (p.id === id ? { ...p, comment: comment } : p))
    );
  };

  const handleChangeCommentMap = (id, comment) => {
    setUploadedMapPics((prev) =>
      prev.map((p) => (p.id === id ? { ...p, comment: comment } : p))
    );
  };



  const onDrop = useCallback(async (acceptedFiles) => {
    setIsLoading(true);

    for (const file of acceptedFiles) {
      let uploadFile = file;

      // If file is .heic, convert to JPEG
      if (
        file.type === "image/heic" ||
        file.name.toLowerCase().endsWith(".heic")
      ) {
        try {
          const convertedBlob = await heic2any({
            blob: file,
            toType: "image/jpeg",
            quality: 0.8,
          });

          uploadFile = new File(
            [convertedBlob],
            file.name.replace(/\.heic$/i, ".jpeg"),
            {
              type: "image/jpeg",
            }
          );
        } catch (conversionError) {
          console.error("HEIC to JPEG conversion failed:", conversionError);
          toast.error("Failed to convert HEIC image.");
          continue;
        }
      }

      const formData = new FormData();
      formData.append("file", uploadFile);

      try {
        const res = await uploadProjectCheckListImage(formData);


        if (res?.data?.url) {
          const payload = {
            project_check_list_id: projectCheckListId,
            image_url: res?.data?.url,
            taken_on: new Date().toISOString(),
            type: isMapPicUploaded ? "map" : "before",
            comment: "",
          };

          const saveImageRes = await saveProjectCheckListImage(payload);


          if (saveImageRes?.status === 200) {
            toast.success("Image uploaded successfully");
            fetchUploadedImages();
          }
        } else if (res?.status === 413) {
          toast.error(
            "Image size is too large. Please upload a smaller image."
          );
        }
      } catch (error) {
        console.error("Image upload failed:", error?.message || error);
      }
    }

    setIsLoading(false);
  });

  const { getRootProps, getInputProps, open, isDragActive } = useDropzone({
    onDrop,
    noClick: true,
    noKeyboard: true,
    accept: {
      "image/*": [],
    },
  });

  const rootProps = !isDisabled ? getRootProps() : {};

   const modalBodyRef = useRef(null);
  const modalHeaderRef = useRef(null);

  useEffect(() => {
    const body = modalBodyRef.current;
    const header = modalHeaderRef.current;

    if (!body || !header) return;

    const handleScroll = () => {
      const scrollTop = body.scrollTop;
      const scrollHeight = body.scrollHeight - body.clientHeight;
      const scrolled = (scrollTop / scrollHeight) * 100;

      if (scrolled >= 10) {
        header.classList.add("scrolled-10"); // ✅ add when >=10%
      } else {
        header.classList.remove("scrolled-10"); // ✅ remove when <10%
      }
    };

    body.addEventListener("scroll", handleScroll);

    return () => {
      body.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      {...rootProps}
      className="modal fade"
      id="addPicsUnitJob"
      tabIndex="-1"
      aria-labelledby="addPicsUnitJobLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-xl modal-dialog-scrollable uploadImage" style={{maxHeight:'80%'}}>
        <div className="modal-content p-3">
          <div className="modal-header" ref={modalHeaderRef} style={{"paddingTop":0}}>
            <h1 id="addPicsUnitJobLabel">
              Uploaded Images
            </h1>
            <p className="subtitle">Use the action buttons below to upload images. Select a status and leave a note for each upload.</p>
<button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => setIsDeleteEnabled(false)}
            ></button>
          </div>

          <div className="modal-body"  ref={modalBodyRef}>
            {!isDisabled && (
              <div
                //   {...getRootProps()}
                className="dropzone border rounded p-4 mb-4 text-center bg-light upload-box"
                //   style={{ cursor: "pointer" }}
              >
                <input {...getInputProps()} />
                {isDragActive ? (
                  <p>Drop the files here ...</p>
                ) : (
                  <p>
                    Drag & drop images here, or click the button below to upload
                  </p>
                )}
              </div>
            )}

            {uploadedPics.length > 0 || uploadedMapPics.length > 0 ? (
              <>
              <div className="d-flex flex-wrap gap-4">
                {uploadedPics.map((pic) => (
                  <>
                    <div
                      key={pic.id}
                      className="border rounded p-3 checklist-image-card"
                      // style={{ width: "200px", minHeight: "300px" }}
                    >
                      <div className="text-center mb-2 thumb">
                        <img
                          disabled={!pic.isEditable}
                          src={pic.image_url}
                          alt="uploaded"
                          style={{
                            width: "100%",
                            height: "167px",
                            objectFit: "cover",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            window.open(pic.image_url, "_blank");
                          }}
                        />
                      </div>

                      <div className="d-flex justify-content-between align-items-center mb-2 datepicker">
                        <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"></rect><path d="M16 2v4M8 2v4M3 10h18"></path></svg>
                        {/* <span>{formatDateToMMDDYYYY(pic.taken_on)}</span> */}
                        <DatePicker
                          disabled={!pic.isEditable}
                          placeholderText="MM/DD/YYYY"
                          default
                          selected={new Date(pic.taken_on)}
                          onChange={(e) => handleDateChange(e, pic?.id)}
                          dateFormat="MM/dd/yyyy"
                          aria-label="Date"
                          className="input-field w-100 mb-0 h-30"
                          // includeDates={
                          //   Object.keys(timeSheetDetails).length > 0
                          //     ? getDatesForISOWeek(timeSheetDetails?.week)
                          //     : ""
                          // }
                        />
                        <div>
                          <i
                            className="bi bi-pencil-square me-2"
                            role="button"
                          ></i>
                          <i
                            className="bi bi-trash text-danger"
                            role="button"
                          ></i>
                        </div>
                      </div>
                      <div className="image-type">
                      <div className="form-check">
                        <input
                          disabled={!pic.isEditable}
                          className="form-check-input"
                          type="radio"
                          name={`type-${pic.id}`}
                          id={`before-${pic.id}`}
                          checked={pic.type === "before"}
                          onChange={() => handleTypeChange(pic.id, "before")}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`before-${pic.id}`}
                        >
                          Before
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          disabled={!pic.isEditable}
                          className="form-check-input"
                          type="radio"
                          name={`type-${pic.id}`}
                          id={`after-${pic.id}`}
                          checked={pic.type === "after"}
                          onChange={() => handleTypeChange(pic.id, "after")}
                        />
                        <label className="form-check-label" htmlFor={pic.id}>
                          After
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          disabled={!pic.isEditable}
                          className="form-check-input"
                          type="radio"
                          name={`type-${pic.id}`}
                          id={`as-built-${pic.id}`}
                          checked={pic.type === "as-built"}
                          onChange={() => handleTypeChange(pic.id, "as-built")}
                        />
                        <label className="form-check-label" htmlFor={pic.id}>
                          As-built
                        </label>
                      </div>
                      </div>
                      <textarea
                        disabled={!pic.isEditable}
                        className="form-control"
                        rows="2"
                        style={{ resize: "none" }}
                        placeholder="Enter Comments..."
                        value={pic.comment}
                        onChange={(e) =>
                          handleChangeComment(pic.id, e.target.value)
                        }
                      ></textarea>
                      {!pic.isEditable && isDeleteEnabled ? (
                        <div className="action-delete" onClick={() => handleDeleteImageCard(pic)}>
                       <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M262.2 48C248.9 48 236.9 56.3 232.2 68.8L216 112L120 112C106.7 112 96 122.7 96 136C96 149.3 106.7 160 120 160L520 160C533.3 160 544 149.3 544 136C544 122.7 533.3 112 520 112L424 112L407.8 68.8C403.1 56.3 391.2 48 377.8 48L262.2 48zM128 208L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 208L464 208L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 208L128 208zM288 280C288 266.7 277.3 256 264 256C250.7 256 240 266.7 240 280L240 456C240 469.3 250.7 480 264 480C277.3 480 288 469.3 288 456L288 280zM400 280C400 266.7 389.3 256 376 256C362.7 256 352 266.7 352 280L352 456C352 469.3 362.7 480 376 480C389.3 480 400 469.3 400 456L400 280z"/></svg>
                        </div>
                      ) : (
                        !pic.isEditable &&
                        !isDisabled && (
                          <Button
                            className="primary-outline mt-2 ms-auto d-table edit-checklist"
                            onClick={() => handleEditImageCard(pic)}
                          >
                            <img
                              className="edit-logo me-2"
                              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAEnRAABJ0QEF/KuVAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAABOBJREFUaIHtmUuMFFUUhr9zq0fARMDpLrt6wBeviEZWxoUbDKMoblygYuIjxPAYE9DExBjjzrh0I0YUMNFEE4hg2DFEQV24m40BA6Ko+Bi6enqmhwRlMs5UHRfdONXVVT3VXT3MOOFf1b1969zz9bnn1n2IqjIfZGbbgU7pOshc07wBycy2A0EVi5dzxkw8A3qfqmTAP+f7HOzpyZ2b7l2ZK7NWqVTZoqr7gcWhnzzgbcfJvlF7jtScACkWh3eKyPuAxLUR4dN8PruVGJhZz5EkEACqPFssjrwV9/usgsRAfA/cb4y3Evg82F6EVwcHh9dE2Zo22YvF0dtEvJdBNgF3AIumeWVShK+M8Tfbtv1XaxB6SnVBb6Fw03CtYovrjhwCnqiVLcsyTwNvhu01jUipVNkm4p8DeQVYmwACIKPKRs8zz7cGwZkQBIBnjPda6PW1UTZjQUqlyjZVPQAsTOB8hKQcVRuXEyL0iPxzZ7i9auaWUM14lN3IoVUdTvpuqHoSOKtKKdZ3wBh84Ot8vvtIBESfiOwNQ1QdZqkIX7juyEbHyQ4AuK5rQ9eHoaYDiUFqObFwqizfGeM9adv2+WYQzRQDcUaEHlWWhmFg4gJ0nQTumfKDSxMTXQej7McMLdkUKEzODISeUr1hvSobRbj0X20NBrq+Ae4NmFFV2bF8+eJKCyDcHnj+YWYgqontONmBKBjg7noIfdFxug/H9RMHcmPgeTimzbSqznryHs2nWBwnO+D72gtE/dsK7CoUcvua9TVjH8RicbivtnYK9KGnYPKh0BRb04LfATdUWYtEdu90/c3I6rdYHN7eGAnOWpY+YttOw7Tsuq4tkjkBUjecSBCJq+p4RGoQH4Rsn7Usf4Nt2+F/vDbFZk6ArAtUK7ArSSSuqqMRaQ+i6ySh2YkWIaCDESkWR54TkX0hm6dhYn3zSISnWO1rFQI6BFIul1eJsI/6nDgNE72OE50T1UjUDydV7SsUcvvb8aEjIJOTZjf1C8oEEI2RaBcCOpMjYgybAxvNcZHM4/l89ppBQAciMjQ0tE6VZVM1cjKfX/JruF2zxE4LAR2IiKoVXJchosfDbZpEYmehkDsQai6lUuUpVe22LP+TZpuzoFJHRLVugYkxfn+wPDQ0tLIFCEqlkddV9RCw1/NMw1YgTqkiMjo6ugT0gSnv+Mm27fODg8NrjDGPieijYD0ILEgCUbOxIVDsTepLKpDxcX04aEOERa5b+dmyZEV1+DeoKURNVjv+pcwR3RSqWB4DAPC3iG53nFzkxiit0iZ7ktD/IaJHVDN78vmlF1L2F6tUICJkIg4qJ4BvgeMipj+fv/l0mj6SKhWI77NbhHcAT0S+9H3t7+rSE7lc7nKH/EusVCCFQvYocLRDvqTSrJ/9dkrzHuRK4Dl3LRyJ6e9KbKuQ4kB+CzzfVS6XV7XlUouqnbQHz3YbFp9xijugOxYoZHzfOlwul1e35V1Clcvl1cbwGXVfdumPfSGkyBurixcrtxqjP1J/gO1RPftt2LamlQgO1UgElydjnidrli3r/jORjbirN9cd2Qp8lNbJdqWqO6ZZk9UpdtZynOzHIrINGOuIZ8k1BvJCKxCQ4DK0Osx4qbZAXEGyy55WNQb8AnLM89iTdDgFNSdudTuhef9B/N/pOshc078bPR6yLS/zQAAAAABJRU5ErkJggg=="
                              alt=""
                            />
                            Edit
                          </Button>
                        )
                      )}

                        {pic.isEditable && (
                        <div className="text-end mt-2" className="checklist-card-action">
                          <div className="action-save" onClick={() => handleSaveImageCard(pic)}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M160 144C151.2 144 144 151.2 144 160L144 480C144 488.8 151.2 496 160 496L480 496C488.8 496 496 488.8 496 480L496 237.3C496 233.1 494.3 229 491.3 226L416 150.6L416 240C416 257.7 401.7 272 384 272L224 272C206.3 272 192 257.7 192 240L192 144L160 144zM240 144L240 224L368 224L368 144L240 144zM96 160C96 124.7 124.7 96 160 96L402.7 96C419.7 96 436 102.7 448 114.7L525.3 192C537.3 204 544 220.3 544 237.3L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 160zM256 384C256 348.7 284.7 320 320 320C355.3 320 384 348.7 384 384C384 419.3 355.3 448 320 448C284.7 448 256 419.3 256 384z"/></svg>
                            Save
                            {/* <img
                              onClick={() => handleSaveImageCard(pic)}
                              style={{ width: "20px", height: "20px" }}
                              className="edit-logo me-2"
                              src={SaveIcon}
                              alt=""
                              disabled={isLoading}
                            /> */}
                          </div>
                          <div className="action-cancel" onClick={() => handleCancelImageCard(pic)}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M431.2 476.5L163.5 208.8C141.1 240.2 128 278.6 128 320C128 426 214 512 320 512C361.5 512 399.9 498.9 431.2 476.5zM476.5 431.2C498.9 399.8 512 361.4 512 320C512 214 426 128 320 128C278.5 128 240.1 141.1 208.8 163.5L476.5 431.2zM64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320z"/></svg>
                            Cancel
                            {/* <img
                              onClick={() => handleCancelImageCard(pic)}
                              style={{ width: "20px", height: "20px" }}
                              className="edit-logo"
                              src={DeleteIcon}
                              alt=""
                              disabled={isLoading}
                            /> */}
                          </div>
                        </div>
                      )}

                    </div>
                  </>
                ))}
              </div>
              <div className="border rounded" style={{marginBottom:'16px', marginTop:'16px'}} ></div>
              <h5 className="modal-title" id="addPicsUnitJobLabel" style={{marginBottom:'16px'}}>
                Uploaded Map Images
              </h5>
              <div className="d-flex flex-wrap gap-4">
              {uploadedMapPics.map((pic) => (
                  <>
                    <div
                      key={pic.id}
                      className="border rounded p-3 checklist-image-card"
                    >
                      <div className="text-center mb-2 thumb">
                        <img
                          disabled={!pic.isEditable}
                          src={pic.image_url}
                          alt="uploaded"
                          style={{
                            width: "100%",
                            height: "167px",
                            objectFit: "cover",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            window.open(pic.image_url, "_blank");
                          }}
                        />
                      </div>

                      <div className="d-flex justify-content-between align-items-center mb-2 datepicker">
                        <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"></rect><path d="M16 2v4M8 2v4M3 10h18"></path></svg>
                        {/* <span>{formatDateToMMDDYYYY(pic.taken_on)}</span> */}
                        <DatePicker
                          disabled={!pic.isEditable}
                          placeholderText="MM/DD/YYYY"
                          default
                          selected={new Date(pic.taken_on)}
                          onChange={(e) => handleDateChangeForMap(e, pic?.id)}
                          dateFormat="MM/dd/yyyy"
                          aria-label="Date"
                          className="input-field w-100 mb-0 h-30"
                          // includeDates={
                          //   Object.keys(timeSheetDetails).length > 0
                          //     ? getDatesForISOWeek(timeSheetDetails?.week)
                          //     : ""
                          // }
                        />
                        <div>
                          <i
                            className="bi bi-pencil-square me-2"
                            role="button"
                          ></i>
                          <i
                            className="bi bi-trash text-danger"
                            role="button"
                          ></i>
                        </div>
                      </div>

                      <textarea
                        disabled={!pic.isEditable}
                        className="form-control"
                        rows="2"
                        style={{ resize: "none" }}
                        placeholder="Enter Comments..."
                        value={pic.comment}
                        onChange={(e) =>
                          handleChangeCommentMap(pic.id, e.target.value)
                        }
                      ></textarea>
                      {!pic.isEditable && isDeleteEnabled ? (
                        <div className="action-delete" onClick={() => handleDeleteImageCard(pic)}>
                       <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M262.2 48C248.9 48 236.9 56.3 232.2 68.8L216 112L120 112C106.7 112 96 122.7 96 136C96 149.3 106.7 160 120 160L520 160C533.3 160 544 149.3 544 136C544 122.7 533.3 112 520 112L424 112L407.8 68.8C403.1 56.3 391.2 48 377.8 48L262.2 48zM128 208L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 208L464 208L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 208L128 208zM288 280C288 266.7 277.3 256 264 256C250.7 256 240 266.7 240 280L240 456C240 469.3 250.7 480 264 480C277.3 480 288 469.3 288 456L288 280zM400 280C400 266.7 389.3 256 376 256C362.7 256 352 266.7 352 280L352 456C352 469.3 362.7 480 376 480C389.3 480 400 469.3 400 456L400 280z"/></svg>
                        </div>
                      ) : (
                        !pic.isEditable &&
                        !isDisabled && (
                          <Button
                            className="primary-outline mt-2 ms-auto d-table edit-checklist btn-secondary"
                            onClick={() => handleEditMapImageCard(pic)}
                          >
                                <img
                              className="edit-logo me-2"
                              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAEnRAABJ0QEF/KuVAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAABOBJREFUaIHtmUuMFFUUhr9zq0fARMDpLrt6wBeviEZWxoUbDKMoblygYuIjxPAYE9DExBjjzrh0I0YUMNFEE4hg2DFEQV24m40BA6Ko+Bi6enqmhwRlMs5UHRfdONXVVT3VXT3MOOFf1b1969zz9bnn1n2IqjIfZGbbgU7pOshc07wBycy2A0EVi5dzxkw8A3qfqmTAP+f7HOzpyZ2b7l2ZK7NWqVTZoqr7gcWhnzzgbcfJvlF7jtScACkWh3eKyPuAxLUR4dN8PruVGJhZz5EkEACqPFssjrwV9/usgsRAfA/cb4y3Evg82F6EVwcHh9dE2Zo22YvF0dtEvJdBNgF3AIumeWVShK+M8Tfbtv1XaxB6SnVBb6Fw03CtYovrjhwCnqiVLcsyTwNvhu01jUipVNkm4p8DeQVYmwACIKPKRs8zz7cGwZkQBIBnjPda6PW1UTZjQUqlyjZVPQAsTOB8hKQcVRuXEyL0iPxzZ7i9auaWUM14lN3IoVUdTvpuqHoSOKtKKdZ3wBh84Ot8vvtIBESfiOwNQ1QdZqkIX7juyEbHyQ4AuK5rQ9eHoaYDiUFqObFwqizfGeM9adv2+WYQzRQDcUaEHlWWhmFg4gJ0nQTumfKDSxMTXQej7McMLdkUKEzODISeUr1hvSobRbj0X20NBrq+Ae4NmFFV2bF8+eJKCyDcHnj+YWYgqontONmBKBjg7noIfdFxug/H9RMHcmPgeTimzbSqznryHs2nWBwnO+D72gtE/dsK7CoUcvua9TVjH8RicbivtnYK9KGnYPKh0BRb04LfATdUWYtEdu90/c3I6rdYHN7eGAnOWpY+YttOw7Tsuq4tkjkBUjecSBCJq+p4RGoQH4Rsn7Usf4Nt2+F/vDbFZk6ArAtUK7ArSSSuqqMRaQ+i6ySh2YkWIaCDESkWR54TkX0hm6dhYn3zSISnWO1rFQI6BFIul1eJsI/6nDgNE72OE50T1UjUDydV7SsUcvvb8aEjIJOTZjf1C8oEEI2RaBcCOpMjYgybAxvNcZHM4/l89ppBQAciMjQ0tE6VZVM1cjKfX/JruF2zxE4LAR2IiKoVXJchosfDbZpEYmehkDsQai6lUuUpVe22LP+TZpuzoFJHRLVugYkxfn+wPDQ0tLIFCEqlkddV9RCw1/NMw1YgTqkiMjo6ugT0gSnv+Mm27fODg8NrjDGPieijYD0ILEgCUbOxIVDsTepLKpDxcX04aEOERa5b+dmyZEV1+DeoKURNVjv+pcwR3RSqWB4DAPC3iG53nFzkxiit0iZ7ktD/IaJHVDN78vmlF1L2F6tUICJkIg4qJ4BvgeMipj+fv/l0mj6SKhWI77NbhHcAT0S+9H3t7+rSE7lc7nKH/EusVCCFQvYocLRDvqTSrJ/9dkrzHuRK4Dl3LRyJ6e9KbKuQ4kB+CzzfVS6XV7XlUouqnbQHz3YbFp9xijugOxYoZHzfOlwul1e35V1Clcvl1cbwGXVfdumPfSGkyBurixcrtxqjP1J/gO1RPftt2LamlQgO1UgElydjnidrli3r/jORjbirN9cd2Qp8lNbJdqWqO6ZZk9UpdtZynOzHIrINGOuIZ8k1BvJCKxCQ4DK0Osx4qbZAXEGyy55WNQb8AnLM89iTdDgFNSdudTuhef9B/N/pOshc078bPR6yLS/zQAAAAABJRU5ErkJggg=="
                              alt=""
                            />
                            Edit
                          </Button>
                        )
                      )}
                      {pic.isEditable && (
                        <div className="text-end mt-2" className="card-action-container">
                          <div className="action-save" onClick={() => handleSaveMapImageCard(pic)}>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M160 144C151.2 144 144 151.2 144 160L144 480C144 488.8 151.2 496 160 496L480 496C488.8 496 496 488.8 496 480L496 237.3C496 233.1 494.3 229 491.3 226L416 150.6L416 240C416 257.7 401.7 272 384 272L224 272C206.3 272 192 257.7 192 240L192 144L160 144zM240 144L240 224L368 224L368 144L240 144zM96 160C96 124.7 124.7 96 160 96L402.7 96C419.7 96 436 102.7 448 114.7L525.3 192C537.3 204 544 220.3 544 237.3L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 160zM256 384C256 348.7 284.7 320 320 320C355.3 320 384 348.7 384 384C384 419.3 355.3 448 320 448C284.7 448 256 419.3 256 384z"/></svg>Save
                          </div>
                          <div className="action-cancel" onClick={() => handleCancelMapImageCard(pic)}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M431.2 476.5L163.5 208.8C141.1 240.2 128 278.6 128 320C128 426 214 512 320 512C361.5 512 399.9 498.9 431.2 476.5zM476.5 431.2C498.9 399.8 512 361.4 512 320C512 214 426 128 320 128C278.5 128 240.1 141.1 208.8 163.5L476.5 431.2zM64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320z"/></svg>
                            Cancel
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                ))}
              </div>
              </>
            ) : (
              <div className="text-center">
                <p>No uploaded pics</p>
              </div>
            )}
          </div>

          {!isDisabled && (
            <div className="mt-4 border-top pt-3 d-flex justify-content-between align-items-center">
              {/* Loader or placeholder */}
              <div style={{ minWidth: "2rem" }}>
                {isLoading && (
                  <div className="spinner-border" role="status"></div>
                )}
              </div>

              {/* Buttons on the right */}
              <div className="text-end">
                {uploadedPics.length > 0 && (
                  <button
                    disabled={isLoading}
                    style={{
                      backgroundColor: "#c24a4a",
                      color: "#fff",
                      marginRight: "10px",
                    }}
                    type="button"
                    className="btn"
                    onClick={() => setIsDeleteEnabled(!isDeleteEnabled)}
                  >
                    {isDeleteEnabled ? "Cancel" : "Delete Images"}
                  </button>
                )}
                <button
                  disabled={isLoading}
                  style={{marginRight: '10px'}}
                  type="button"
                  onClick={() => {
                    open();
                    setIsMapPicUploaded(true);
                  }}
                  className="btn btn-primary"
                >
                  + Add Map Pictures
                </button>
                <button
                  disabled={isLoading}
                  type="button"
                  onClick={() => {
                    open();
                    setIsMapPicUploaded(false);
                  }}
                  className="btn btn-primary"
                >
                  + Add Project Pictures
                </button>

              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddpicsUnitJobModal;
